/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../../../assets/Icons";
import CommonBankLogo from "../../../../components/_utils/CommonBankLogo";
import Chips from "../../../../components/_utils/CommonButtons/Chips/index.jsx";
import SwitcherTabs from "../../../../components/_utils/CommonButtons/SwitcherTabs";
import TopNavSmallButton from "../../../../components/_utils/CommonButtons/TopNavSmallButton";
import CommonContainerCard from "../../../../components/_utils/CommonContainerCard/index.jsx";
import CommonDetailCard from "../../../../components/_utils/CommonDetailCard";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect";
import SmallPopup from "../../../../components/_utils/CommonSmallPopup";
import CommonToast from "../../../../components/_utils/CommonToast";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import { formatAccountNumber } from "../../../../components/_utils/FormatAccountNumber";
import FormatAmount from "../../../../components/_utils/FormatAmount/FormatAmount";
import MediumImagePopup from "../../../../components/_utils/MediumImagePopup";
import PaginationComponent from "../../../../components/_utils/PaginationComponent";
import TimelineStatusBar from "../../../../components/_utils/TimelineCommonComponents/TimelineStatusBar";
import TimelinePopupContent from "../../../../components/_utils/TimelinePopupContent";
import TitleSubtitlePair from "../../../../components/_utils/TitleSubtitlePair";
import BeneScheduleTxnDeclinePopup from "../../../../components/_utils/TransactionCommonComponents/CommonDeclinePopups/BeneScheduleTxnDeclinePopup";
import UniversalRefreshToast from "../../../../components/_utils/UniversalRefreshToast";
import BeneficiaryAccountDetailsPopup from "../../../../components/Accounts/BeneficiaryAccount/BeneficiaryAccountDetailsPopup/index.jsx";
import CommonQuickActionButtons from "../../../../components/_utils/CommonQuickActionButtons/index.jsx";
import CommonTimeLineCard, {
  addLifeCycleStatus,
} from "../../../../components/CommonTimeLineCard";
import Loader from "../../../../components/Loader/Index";
import {
  formatDate,
  formatTimeSlot,
} from "../../../../components/ScheduleTransactions/helpers";
import ScheduleTxnOccurrencesPopup from "../../../../components/ScheduleTransactions/ScheduleTxnOccurrencesPopup";
import BeneficiaryTransactionGridView from "../../../../components/Transactions/BeneficiaryTransaction/BeneficiaryTransactionGridView/index.jsx";
import ScheduleBeneficiaryTransactionViewAllPopup from "../../../../components/Transactions/ScheduleBeneficiaryTransaction/ScheduleBeneficiaryTransactionViewAllPopup/index.jsx";
import useRestrictedAction from "../../../../hooks/useRestrictedAction";
import { disableSwitcher } from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import { beneficiaryTransactionsViewAll } from "../../../../redux/features/transactions/beneficiaryTransactions/index.js";
import {
  clearScheduledBeneficiaryErrors,
  scheduledBeneficiaryAddLabel,
  scheduledBeneficiaryApprove,
  scheduledBeneficiaryDetailsById,
  scheduledBeneficiaryDiscard,
  scheduledBeneficiaryOccurrences,
  scheduledBeneficiaryRemoveLabel,
} from "../../../../redux/features/transactions/scheduleBeneficiaryTransactions/index.js";
import {
  GlobalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider";
import formatDateViewAll from "../../../../utils/formatDateViewAll";
import globalText from "../../../../utils/globalText";
import { globalTextFormat } from "../../../../utils/globalTextFormat.js";
import useCategories from "../../../../utils/useCategories";

const ScheduleBeneficiaryTransactionDetails = ({
  isPopup,
  txn_id,
  detailSelected,
  preApproveAdvice,
  postApproveAdvice,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const paramId = useParams().id;
  const scrollContainerRef = useRef(null);
  const categoryMapper = useCategories();
  const id = txn_id ?? paramId;
  const [, setIsOpen] = useState(false);
  const [isloading, setIsLoading] = useState(true);
  const [scheduleId, setScheduleId] = useState("");
  const [btnClicked, setbtnClicked] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [scheduleAmt, setScheduleAmt] = useState("");
  const [scheduleName, setScheduleName] = useState("");
  const [doneBinding, setDoneBinding] = useState(false);
  const [scheduleSrcId, setScheduleSrcId] = useState("");
  const [selectedImage, setSelectedImage] = useState({});
  const [openImageUrl, setOpenImageUrl] = useState(false);
  const [animationClass, setAnimationClass] = useState("");
  const [scheduleBeneId, setScheduleBeneId] = useState("");
  const [scheduleSrcIFSC, setScheduleSrcIFSC] = useState("");
  const [scheduleEndDate, setScheduleEndDate] = useState("");
  const [transactionData, setTransactionData] = useState([]);
  const [scheduleCategory, setScheduleCategory] = useState("");
  const [scheduleBeneName, setScheduleBeneName] = useState("");
  const [scheduleBeneIFSC, setScheduleBeneIFSC] = useState("");
  const [scheduleTimeSlot, setScheduleTimeSlot] = useState("");
  const [showPromptModal, setShowPromptModal] = useState(false);
  const [scheduleDeleted, setScheduleDeleted] = useState(false);
  const [scheduleFrequency, setScheduleFrequency] = useState("");
  const [scheduleStartDate, setScheduleStartDate] = useState("");
  const [scheduleCreatedOn, setScheduleCreatedOn] = useState("");
  const [scheduleCreatedBy, setScheduleCreatedBy] = useState("");
  const [showBeneAccModal, setShowBeneAccModal] = useState(false);
  const [showRejectPrompt, setShowRejectPrompt] = useState(false);
  const [opentimelinepopup, SetopenTimelinePopup] = useState(false);
  const [scheduleOccurrences, setScheduleOccurrences] = useState("");
  const [scheduleBeneTxnList, setScheduleBeneTxnList] = useState([]);
  const [isScheduleRejected, setIsScheduleRejected] = useState(false);
  const [isScheduleApproved, setIsScheduleApproved] = useState(false);
  const [scheduleUpdatedData, setScheduleUpdatedData] = useState(null);
  const [scheduleSrcAcctNumber, setScheduleSrcAcctNumber] = useState("");
  const [scheduleRejectMessage, setScheduleRejectMessage] = useState("");
  const [schedulePaymentMethod, setSchedulePaymentMethod] = useState("");
  const [showOccurrencesModal, setShowOccurrencesModal] = useState(false);
  const [showApprovalTimeline, setShowApprovalTimeline] = useState(false);
  const [scheduleBeneApproved, setScheduleBeneApproved] = useState(true);
  const [scheduleBeneAcctNumber, setScheduleBeneAcctNumber] = useState("");
  const [scheduleApproveFailed, setScheduleApproveFailed] = useState(false);
  const [scheduleOccurrenceDates, setScheduleOccurrenceDates] = useState([]);
  const [isScheduleConfidential, setIsScheduleConfidential] = useState(false);
  const dropdownOptions = PaginationConfiguration.paginationOptions;
  const [pageSize, setPageSize] = useState(dropdownOptions[0]);
  const [selectedValue, setSelectedValue] = useState(dropdownOptions[0]);
  const [selectedDetail, setSelectedDetail] = useState(
    detailSelected === "Additional details" ? "Additional details" : "Details",
  );

  const [scheduleApproveFailedMessage, setScheduleApproveFailedMessage] =
    useState("");
  const [showScheduleHistoryPopup, setShowScheduleHistoryPopup] =
    useState(false);
  const [showScheduleConfidentialPopup, setShowScheduleConfidentialPopup] =
    useState(false);
  const [showScheduleCategoryPopup, setShowScheduleCategoryPopup] =
    useState(false);
  const [index, setIndex] = useState(
    selectedDetail === "Details"
      ? GlobalConfiguration?.lengthCheckZero
      : selectedDetail === "Additional details"
        ? GlobalConfiguration?.lengthCheckOne
        : selectedDetail === "Transaction created"
          ? GlobalConfiguration?.lengthCheckTwo
          : selectedDetail === "Assigned Labels"
            ? GlobalConfiguration?.lengthCheckThree
            : GlobalConfiguration?.lengthCheckZero,
  );

  const [prevIndex, setPrevIndex] = useState(
    GlobalConfiguration?.lengthCheckZero,
  );

  const services = useSelector((state) => state.refreshToken.services);
  const {
    scheduledBeneficiaryDetailsLoading,
    scheduledBeneficiaryDetailsData,
    scheduledBeneficiaryRejectError,
    scheduledBeneficiaryDiscardLoading,
    scheduledBeneficiaryDiscardError,
  } = useSelector((s) => s.scheduleBeneficiaryTransactions);

  const hasModService = services?.includes("BAScheduledTxn");
  const hasOccurrenceService = services?.includes("BOScheduledTxn");
  const [openApprovalTimeline, setOpenApprovalTimeline] = useState(
    Array(
      scheduledBeneficiaryDetailsData?.[0]?.logs?.length ||
        GlobalConfiguration?.lengthCheckZero,
    ).fill(false),
  );

  const [labels, setLabels] = useState([]);
  const [labelDetails, setLabelDetails] = useState([]);
  const [showLabelsPopup, setShowLabelsPopup] = useState(false);
  const [labelPopupLoading, setLabelPopupLoading] = useState(false);
  const labelActionDispatchedRef = useRef(false);

  const labelTxnIds = [id].filter(Boolean);

  const categoryId =
    scheduledBeneficiaryDetailsData?.transaction?.[0]?.category_id?.category_id;

  const categoryIcon = categoryMapper(categoryId);

  useEffect(() => {
    let availableLabels = sessionStorage?.getItem(
      "scheduleBeneficiaryTxnLabels",
    );
    if (availableLabels) {
      setLabels(JSON.parse(availableLabels));
    }
  }, []);

  useEffect(() => {
    setLabelDetails(
      scheduledBeneficiaryDetailsData?.transaction?.[0]?.labels ?? [],
    );
  }, [scheduledBeneficiaryDetailsData]);

  const handleAssignLabelsProp = async (labelsToAssign) => {
    setLabelPopupLoading(true);
    const res = await dispatch(
      scheduledBeneficiaryAddLabel({
        record_ids: labelTxnIds,
        labels: labelsToAssign,
      }),
    );
    if (scheduledBeneficiaryAddLabel?.fulfilled?.match(res)) {
      toast.dismiss();
      CommonToast({
        text: "Labels assigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
      });
      dispatch(scheduledBeneficiaryDetailsById({ id }));
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
      setSelectedDetail("Assigned Labels");
      setIndex(GlobalConfiguration.lengthCheckThree);
    } else {
      toast.dismiss();
      CommonToast({
        text: "Failed to assign labels.",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
      });
    }
    setLabelPopupLoading(false);
    return scheduledBeneficiaryAddLabel?.fulfilled?.match(res);
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setLabelPopupLoading(true);
    const res = await dispatch(
      scheduledBeneficiaryRemoveLabel({
        record_ids: labelTxnIds,
        labels: labelsToUnassign,
      }),
    );
    if (scheduledBeneficiaryRemoveLabel?.fulfilled?.match(res)) {
      toast.dismiss();
      CommonToast({
        text: "Labels unassigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
      });
      dispatch(scheduledBeneficiaryDetailsById({ id }));
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
      setSelectedDetail("Assigned Labels");
      setIndex(GlobalConfiguration.lengthCheckThree);
    } else {
      toast.dismiss();
      CommonToast({
        text: "Failed to unassign labels.",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
      });
    }
    setLabelPopupLoading(false);
    return scheduledBeneficiaryRemoveLabel?.fulfilled?.match(res);
  };

  const handleLabelClose = () => {
    setShowLabelsPopup(false);
    if (!labelActionDispatchedRef.current) return;
    labelActionDispatchedRef.current = false;
    setIndex(GlobalConfiguration.lengthCheckThree);
  };

  const handleBeneAccModalClose = () => {
    setShowBeneAccModal(false);
    dispatch(
      scheduledBeneficiaryDetailsById({
        id,
      }),
    );
  };

  const handleScheduleDiscard = () => {
    (async () => {
      UniversalRefreshToast("Discarding schedule.");
      let a = await dispatch(scheduledBeneficiaryDiscard({ id: scheduleId }));
      if (a?.payload?.status ?? false) {
        toast.dismiss();
        setTimeout(() => {
          CommonToast({
            text: "Schedule discarded successfully.",
            icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
            variant: "var(--success)",
          });
        }, 2500);
        setShowPromptModal(false);
        setScheduleDeleted(true);
      } else {
        CommonToast({
          text: scheduledBeneficiaryDiscardError,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
        });
        setShowPromptModal(false);
      }
      dispatch(
        scheduledBeneficiaryDetailsById({
          id,
        }),
      );
    })();
  };

  const { showRestrictedAction, RestrictedActionPopup } = useRestrictedAction();

  const actionRestricted = () => {
    showRestrictedAction({
      path: `/beneficiary_transaction_dashboard/schedule_view_all/schedule_detail_page/${txn_id}`,
    });
  };

  const runIfNotPopup =
    (fn, warnMsg) =>
    (...args) => {
      if (isPopup) {
        actionRestricted();
        return;
      }
      if (typeof fn === "function") return fn(...args);
    };

  const safeSetShowPromptModal = () => {
    if (isPopup) {
      actionRestricted();
      return;
    }
    setShowPromptModal(true);
  };

  const handleSelect = (value) => {
    setCurrentPage(1);
    setSelectedValue(value);
    setPageSize(value);
  };

  const handlePagination = (page) => {
    setCurrentPage(page);
  };

  const handleShowOccurrences = () => {
    (async () => {
      let response = await dispatch(
        scheduledBeneficiaryOccurrences({
          paramsData: {
            frequency: scheduleFrequency,
            transaction_start_date: scheduleStartDate,
            transaction_end_date: scheduleEndDate,
          },
          services,
          navigate,
        }),
      );
      setScheduleOccurrenceDates(response?.payload?.dates ?? []);
      setShowOccurrencesModal(true);
    })();
  };

  const handleApprove = () => {
    (async () => {
      setbtnClicked((prev) => ({
        ...prev,
        [scheduleId]: "Approve",
      }));
      UniversalRefreshToast("Approving schedule.");

      preApproveAdvice?.call();
      const response = await dispatch(
        scheduledBeneficiaryApprove({ id: scheduleId }),
      );
      if (response?.payload?.status ?? false) {
        toast.dismiss();
        setIsScheduleApproved(true);
        dispatch(
          scheduledBeneficiaryDetailsById({
            id,
          }),
        );
        setTimeout(() => {
          CommonToast({
            text: "Schedule approved successfully.",
            icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
            variant: "var(--success)",
          });
        }, 2500);
        if (isPopup) {
          setTimeout(() => {
            setShowRejectPrompt(false);
            window.location.reload();
          }, GlobalConfiguration?.autoCloseTime);
        }
      } else {
        setbtnClicked((prev) => ({
          ...prev,
          [scheduleId]: "none",
        }));
        setScheduleApproveFailed(true);
        setScheduleApproveFailedMessage(
          response?.payload?.errors?.base?.[0]?.errors?.[0] ??
            "Something went wrong while rejecting transaction",
        );
        toast.dismiss();

        CommonToast({
          text: response?.payload?.errors?.base?.[0]?.errors?.[0],
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
        });
        setbtnClicked((prev) => ({
          ...prev,
          [scheduleUpdatedData?.[0]?.txn_id]: "none",
        }));
      }
      postApproveAdvice?.call();
    })();
  };

  const onApproveClick = () => {
    if (hasModService) {
      setbtnClicked((prev) => ({
        ...prev,
        [scheduleId]: "Approve",
      }));
      handleApprove();
    } else {
      navigate("/feature_not_assigned", {
        state: { unavailableService: "BAScheduledTxn" },
      });
    }
  };

  const normalizeAdditionalDetails = (details = []) => {
    return details.map((item) => {
      const hasValue =
        item.hasOwnProperty("value") &&
        item.value !== null &&
        item.value !== "" &&
        !(
          Array.isArray(item.value) &&
          item.value.length === GlobalConfiguration?.lengthCheckZero
        );

      return {
        ...item,
        value: hasValue ? item.value : "Not given",
      };
    });
  };

  const allAdditionalData =
    scheduledBeneficiaryDetailsData?.transaction?.flatMap((txn) =>
      normalizeAdditionalDetails(txn?.additional_data?.data ?? []),
    ) || [];

  const nonAttachmentDetails = allAdditionalData.filter(
    (item) => !["hyperlink", "upload"].includes(item.data_type),
  );

  const attachments = allAdditionalData.filter((item) =>
    ["hyperlink", "upload"].includes(item.data_type),
  );

  const detailSectionAdditionalDetailsDiv = (
    <div className={animationClass}>
      <div className="flex flex-col Qmd:flex-row items-start gap-gap-md pb-padding-md text-text-primary">
        {nonAttachmentDetails?.length > GlobalConfiguration?.lengthCheckZero ? (
          <CommonDetailCard
            cardTitle="Additional details"
            variant="third"
            numCols={
              nonAttachmentDetails.length ===
              GlobalConfiguration?.lengthCheckOne
                ? GlobalConfiguration?.lengthCheckOne
                : GlobalConfiguration?.lengthCheckTwo
            }
            entries={nonAttachmentDetails.map((item) => {
              switch (item.data_type) {
                case "from_year_to_year":
                  return {
                    heading: item.name,
                    content:
                      item.value?.from && item.value?.to
                        ? `${item.value.from} - ${item.value.to}`
                        : "Not given",
                    type: "text",
                  };

                case "date_range":
                  return {
                    heading: item.name,
                    content:
                      item.value?.start_date && item.value?.end_date
                        ? `${item.value.start_date} - ${item.value.end_date}`
                        : "Not given",
                    type: "text",
                  };

                case "multi_select_list":
                  return {
                    heading: item.name,
                    content:
                      Array.isArray(item.value) && item.value.length
                        ? item.value.join(", ")
                        : "Not given",
                    type: "text",
                  };

                case "toggle":
                  return {
                    heading: item.name,
                    content: item.value === true ? "Yes" : "No",
                    type: "text",
                  };

                default:
                  return {
                    heading: item.name,
                    content: item.value || "Not given",
                    type: "text",
                  };
              }
            })}
          />
        ) : (
          <CommonDetailCard
            cardTitle="Additional details"
            variant="third"
            numCols={GlobalConfiguration?.lengthCheckOne}
            entries={[
              {
                content:
                  "Additional details are not supported for the selected category.",
              },
            ]}
          />
        )}

        {attachments.length > GlobalConfiguration?.lengthCheckZero && (
          <>
            <CommonDetailCard
              cardTitle={globalText?.ATTACHMENTS}
              numCols={GlobalConfiguration?.lengthCheckOne}
              variant="third"
              entries={attachments.map((obj, index) => {
                switch ((obj.data_type || "").toLowerCase()) {
                  case "hyperlink": {
                    const isValid =
                      obj?.value &&
                      obj.value !== "Not given" &&
                      obj.value !== "#" &&
                      obj.value !== "";

                    return {
                      content: isValid ? obj.value : "Not given",
                      heading: "URL",
                      type: isValid ? "link" : "text",
                    };
                  }

                  default: {
                    const ob = obj?.value;
                    if (!ob || ob === "Not given" || typeof ob !== "object") {
                      return {
                        heading: "File",
                        content: "Not given",
                        type: "text",
                      };
                    }

                    const mimeType =
                      ob?.metadata?.mime_type || "application/octet-stream";

                    const fileName = ob?.metadata?.filename || "Unknown file";
                    const size = ob?.metadata?.size ?? "0";
                    const fileUrl = ob?.file_url;

                    if (!fileUrl) {
                      return {
                        heading: "File",
                        content: "Not given",
                        type: "text",
                      };
                    }

                    if (mimeType.startsWith("image/")) {
                      return {
                        heading: "Image",
                        type: "image",
                        content: {
                          fileName,
                          size,
                          mimeType,
                          url: fileUrl,
                          onUrlClick: () => {
                            setOpenImageUrl(true);
                            setSelectedImage({
                              name: fileName,
                              url: fileUrl,
                            });
                          },
                        },
                      };
                    }

                    return {
                      heading: "File",
                      type: "file",
                      content: {
                        fileName,
                        size,
                        mimeType,
                        url: fileUrl,
                        onUrlClick: () => {
                          window.open(fileUrl, "_blank")?.focus();
                        },
                      },
                    };
                  }
                }
              })}
            />
          </>
        )}
      </div>
    </div>
  );

  useEffect(() => {
    if (!isPopup) return;

    const initialDetail =
      detailSelected === "Additional details"
        ? "Additional details"
        : "Details";

    setSelectedDetail(initialDetail);
    setIndex(
      initialDetail === "Additional details"
        ? GlobalConfiguration?.lengthCheckOne
        : GlobalConfiguration?.lengthCheckZero,
    );
  }, [isPopup, detailSelected]);

  const handleTimelinePopup = () => {
    if (isPopup) {
      actionRestricted();
    } else {
      SetopenTimelinePopup(true);
      setShowApprovalTimeline(true);
    }
  };

  const PopupcloseIcons = () => {
    setOpenApprovalTimeline([]);
    SetopenTimelinePopup(false);
    setShowApprovalTimeline(false);
  };
  const handleApprovalTimeline = (index) => {
    setOpenApprovalTimeline((prevOpenDivs) => {
      if (!Array.isArray(prevOpenDivs)) {
        return [];
      }
      const newOpenDivs = [...prevOpenDivs];
      newOpenDivs[index] = !newOpenDivs[index];
      return newOpenDivs;
    });
  };

  useLayoutEffect(() => {
    if (index !== prevIndex) {
      const direction =
        index > prevIndex ? "animate-slide-next" : "animate-slide-prev";

      setAnimationClass(direction);
      setPrevIndex(index);
    }
  }, [index, prevIndex]);

  const hasTxnList =
    scheduleBeneTxnList.length > GlobalConfiguration?.lengthCheckZero;

  useEffect(() => {
    if (!doneBinding || scheduledBeneficiaryDetailsLoading) return;

    if (selectedDetail === "Transaction created" && !hasTxnList) {
      setSelectedDetail("Details");
      setIndex(GlobalConfiguration?.lengthCheckZero);
      setCurrentPage(1);
    }
  }, [
    hasTxnList,
    doneBinding,
    scheduledBeneficiaryDetailsLoading,
    selectedDetail,
  ]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        dispatch(disableSwitcher());
        const response = await dispatch(
          scheduledBeneficiaryDetailsById({
            id,
          }),
        );
        if (
          response?.error?.status === 404 ||
          response?.payload?.status === 404 ||
          response?.payload?.statusCode === 404
        ) {
          navigate("*");
          return;
        }
      } catch (error) {
        console.error("Failed to load schedule transaction details", error);
      }
    };
    fetchData();
  }, [dispatch, paramId, txn_id, navigate]);

  useEffect(() => {
    const handleFetch = async () => {
      setIsLoading(true);
      let data = await dispatch(
        beneficiaryTransactionsViewAll({
          page_item_count: pageSize,
          page_no: currentPage,
          txn_id: scheduleBeneTxnList || [],
        }),
      );
      setIsLoading(false);
      setTransactionData(data);
    };
    if (scheduleBeneTxnList?.length) {
      handleFetch();
    }
  }, [scheduleBeneTxnList, currentPage, pageSize]);

  useEffect(() => {
    if (
      showOccurrencesModal ||
      showPromptModal ||
      showRejectPrompt ||
      showBeneAccModal
    ) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [
    showOccurrencesModal,
    showPromptModal,
    showRejectPrompt,
    showBeneAccModal,
  ]);

  useEffect(() => {
    if (!scheduledBeneficiaryDetailsData) {
      setDoneBinding(true);
      return;
    }

    dispatch(clearScheduledBeneficiaryErrors());

    const uiState = addLifeCycleStatus({
      lifecycle_status:
        scheduledBeneficiaryDetailsData?.transaction?.[0]?.lifecycle_status,
      services,
      cardType: "single",
    });

    const newData = {
      ...scheduledBeneficiaryDetailsData,
      transaction: scheduledBeneficiaryDetailsData?.transaction?.map(
        (account) => ({
          ...account,
          loading: false,
          error: false,
          message: "",
          last_updated_user_id_check: false,
          statusName: uiState.statusName,
          statusColor: uiState.statusColor,
          distributionStatusName: uiState.distributionStatusName,
          distributionStatusColor: uiState.distributionStatusColor,
          barColor: uiState.barColor,
          barValue: uiState.barValue,
        }),
      ),
    };

    const data = newData?.transaction?.[0];
    if (data) {
      setScheduleId(data?.txn_id ?? "");
      setScheduleName(data?.scheduled_name ?? "Not available");
      setScheduleAmt(data?.amount ?? "0");
      setSchedulePaymentMethod(data?.payment_method ?? "");
      setScheduleCategory(data?.category_id ?? "");
      setScheduleDeleted((data?.deleted ?? "N") === "Y");
      setScheduleFrequency(data?.frequency ?? "");
      setScheduleStartDate(data?.transaction_start_date ?? "1970-1-1");
      setScheduleEndDate(data?.transaction_end_date ?? "1970-1-1");
      setScheduleTimeSlot(data?.slot ?? " - ");
      setScheduleOccurrences(data?.occurrences ?? "0");
      setScheduleCreatedOn(data?.created_on ?? "");
      setScheduleCreatedBy(data?.txn_initiator ?? "");
      setIsScheduleRejected(data?.rejected === "Y" || data?.rejected === true);
      setScheduleRejectMessage(data?.rejection_reason ?? "");
      setIsScheduleApproved((data?.approved ?? "N") === "Y");
      setIsScheduleConfidential(
        (data?.confidential_transaction ?? "N") === "Y",
      );
      setScheduleSrcAcctNumber(data?.owner_account_bank_acc_no ?? "");
      setScheduleSrcIFSC(data?.owner_account_ifsc_code ?? "");
      setScheduleSrcId(data?.owner_account_id ?? "");
      setScheduleBeneAcctNumber(data?.beneficiary_account_bank_acc_no ?? "");
      setScheduleBeneIFSC(data?.beneficiary_account_ifsc_code ?? "");
      setScheduleBeneId(data?.beneficiary_account_id ?? "");
      setScheduleBeneApproved(
        (data?.beneficiary_account_approval_status ?? "pending") !== "pending",
      );
      setScheduleBeneName(data?.beneficiary_account_name ?? "");
      setScheduleBeneTxnList(data?.beneficiary_transaction_ids ?? []);
    }

    setScheduleUpdatedData((prev) =>
      JSON.stringify(prev) === JSON.stringify(newData) ? prev : newData,
    );

    setScheduleId(
      scheduledBeneficiaryDetailsData?.transaction?.[0]?.txn_id ?? "",
    );

    setDoneBinding(true);
  }, [scheduledBeneficiaryDetailsData]);

  return (
    <>
      <>{RestrictedActionPopup}</>
      {showLabelsPopup && (
        <div
          onClick={(e) => {
            e.stopPropagation();
            setShowLabelsPopup(true);
          }}
          className="fixed left-left-base w-full top-top-base h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal"
        >
          <CommonAssignLabelPopup
            headerTitle="Assign/unassign labels:"
            headersubtext="Labels will be used to generate statistics for the associated transactions."
            closehandleFunction={handleLabelClose}
            closeisDisabled={false}
            labels={labels}
            setLabels={setLabels}
            LabelAccounts={labelTxnIds}
            isLabelPopupOpen={showLabelsPopup}
            filteredData={(scheduledBeneficiaryDetailsData?.transaction || [])
              ?.filter((t) => labelTxnIds.includes(t.txn_id))
              ?.map((t) => ({ ...t, id: t.txn_id }))}
            onClose={handleLabelClose}
            loading={labelPopupLoading}
            setLoading={setLabelPopupLoading}
            handleAssignLabels={handleAssignLabelsProp}
            handleUnassignLabels={handleUnassignLabelsProp}
          />
        </div>
      )}

      {showPromptModal && (
        <div className="fixed z-z-index-max flex items-center justify-center  top-left-base left-left-base w-full h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <SmallPopup
            headerTitle="Confirm discarding this schedule?"
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            subtext="No future transactions will be generated from this schedule."
            btnOneText="Cancel"
            btnOneHandleFunction={() => {
              setShowPromptModal(false);
            }}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText="Discard"
            btnTwoHandleFunction={handleScheduleDiscard}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={false}
            btnTwoIsLoaderNeeded={true}
            btnTwoHoverOption="black"
            btnTwoLoading={scheduledBeneficiaryDiscardLoading ?? false}
          />
        </div>
      )}
      {showOccurrencesModal && (
        <ScheduleTxnOccurrencesPopup
          closeCallback={() => setShowOccurrencesModal(false)}
          occurrences={scheduleOccurrenceDates}
        />
      )}
      {showRejectPrompt && (
        <BeneScheduleTxnDeclinePopup
          allTxnData={scheduleUpdatedData?.transaction}
          handleClose={() => {
            setShowRejectPrompt(false);
            setbtnClicked((prev) => ({
              ...prev,
              [scheduleId]: "none",
            }));
          }}
          txnId={scheduleId}
          updateAllTxn={(updatedData) => {
            setScheduleUpdatedData((prev) => ({
              ...prev,
              transaction: updatedData,
            }));
          }}
          onRejectSuccess={() => {
            setShowRejectPrompt(false);
            window.location.reload();
          }}
          type="beneScheduleTxnDetail"
          toastType="singleSchedule"
        />
      )}

      {openImageUrl && (
        <>
          <div className="fixed top-top-base left-left-base w-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
            <MediumImagePopup
              image={selectedImage}
              closehandleFunction={() => {
                setOpenImageUrl(false);
              }}
            />
          </div>
        </>
      )}

      {opentimelinepopup && (
        <>
          <LargePopupRedirect
            headerTitle="Schedule timeline"
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            headertextSize="font-md"
            closeiconenabledBgColor="var(--primary-nav)"
            closeiconisLoading={false}
            closeiconhandleFunction={PopupcloseIcons}
            closeicon={ICONS?.CLOSE}
            closeiconhoverOption="white"
            closeiconbtnType={"button"}
            closeiconisDisabled={false}
            closeicondisabledBgColor={""}
            closeiconbuttonRef={null}
            closeicontitle={"Close"}
            btnType={"button"}
            handleFunction={() => {}}
            enabledBgColor={"var(--positive-act)"}
            hoverOption={"dark"}
            outLineColor={""}
            enabledTextColor={"var(--text-primary)"}
            fullWidthRequired={false}
            isDisabled={false}
            disabledTextColor={""}
            disabledBgColor={""}
            isLoading={false}
            buttonRef={null}
            inActiveVariantNeeded={false}
            isLoaderNeeded={false}
            isscrollRequired={true}
          >
            <TimelinePopupContent
              logsData={scheduleUpdatedData?.transaction}
              handleApprovalClick={handleTimelinePopup}
              showDistributionRightIcon={false}
              showApprovalLeftIcon={false}
              showApprovalTimeline={showApprovalTimeline}
              openApprovalTimeline={openApprovalTimeline}
              handleApprovalTimeline={handleApprovalTimeline}
              setOpenApprovalTimeline={setOpenApprovalTimeline}
              cardType={"single"}
              popUpMode={true}
            />
          </LargePopupRedirect>
        </>
      )}

      {showBeneAccModal && (
        <div
          className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-PopUp-BackDrop bg-opacity-light-opacity"
          onClick={() => {
            handleBeneAccModalClose();
          }}
        >
          <BeneficiaryAccountDetailsPopup
            closeBeneAccountDetailModal={handleBeneAccModalClose}
            bene_account_id={scheduleBeneId}
            type={"bene_account_detail_modal"}
          />
        </div>
      )}

      {showScheduleHistoryPopup && (
        <ScheduleBeneficiaryTransactionViewAllPopup
          title={"Schedule history"}
          subtitle={
            "All scheduled transaction related to beneficiary are listed below."
          }
          closeCallback={() => setShowScheduleHistoryPopup(false)}
          type={"history"}
          payload={{
            id: scheduleBeneId,
            number: scheduleBeneAcctNumber,
            name: scheduleBeneName,
            schedule_acc_name: scheduleBeneName,
          }}
        />
      )}

      {showScheduleCategoryPopup && (
        <ScheduleBeneficiaryTransactionViewAllPopup
          title={"Schedule history"}
          subtitle={
            "All scheduled transaction related to beneficiary are listed below."
          }
          closeCallback={() => setShowScheduleCategoryPopup(false)}
          type={"category"}
          payload={scheduleCategory}
        />
      )}

      {showScheduleConfidentialPopup && (
        <ScheduleBeneficiaryTransactionViewAllPopup
          title={"Confidential history"}
          subtitle={
            "All scheduled transaction related to beneficiary are listed below."
          }
          closeCallback={() => setShowScheduleConfidentialPopup(false)}
          type={"confidential"}
          payload={{
            id: scheduleBeneId,
            number: scheduleBeneAcctNumber,
            name: scheduleBeneName,
            schedule_acc_name: scheduleBeneName,
          }}
        />
      )}

      <div
        className={`flex flex-col overflow-hidden ${isPopup ? "h-full" : "h-screen"}`}
      >
        {!doneBinding || scheduledBeneficiaryDetailsLoading ? (
          <div className="w-full h-full-height flex flex-row justify-center items-center">
            <Loader />
          </div>
        ) : (
          <>
            <div
              className={`bg-primary-nav ${
                isPopup
                  ? "hidden"
                  : "h-loader-lg Qsmd:h-navbar-breadcrumb-height flex Qsmd:flex-shrink-0"
              }`}
            ></div>
            <div
              ref={scrollContainerRef}
              className="flex flex-col flex-1 overflow-y-auto overflow-x-hidden scroll-py-top_md"
            >
              {transactionData?.payload?.transactions?.length >
                GlobalConfiguration?.lengthCheckZero &&
                selectedDetail === "Transaction created" && (
                  <div
                    style={{
                      zIndex: "var(--z-index-fixed-ui)",
                      width: "var(--width-full)",
                      bottom: "var(--bottom-base)",
                      borderRadius: "var(--rounded-none)",
                    }}
                    className="bg-primary-nav h-pagination-height fixed w-full"
                  >
                    <PaginationComponent
                      handleSelect={handleSelect}
                      selectedValue={selectedValue}
                      data={transactionData?.payload}
                      pageSize={pageSize}
                      dropdownOptions={dropdownOptions}
                      handlePagination={handlePagination}
                      currentPage={currentPage}
                      setIsOpen={setIsOpen}
                    />
                  </div>
                )}

              {!isPopup && (
                <>
                  <div className="sched-mobile-nav-bar fixed top-top-base left-left-base mt-margin-base w-full z-z-index-header bg-primary-nav shadow-box-shadow-bottom Qsmd:hidden block">
                    <TopNavComponent
                      topNavHeader={globalText?.SCHEDULE}
                      topNavSubText={globalTextFormat(
                        globalText?.SCHEDULE_DETAILS,
                        [0],
                      )}
                      isFormattingNotRequired={true}
                    />
                  </div>
                </>
              )}
              <div className="flex flex-col flex-1 bg-primary-nav">
                <div>
                  <div className="h-auto bg-primary-nav Qsmd:flex Qsmd:flex-row justify-center relative">
                    <div className="sched-detail-section-inner-1024 w-auto Qsmd:max-w-screen-Qlg Qsmd:w-std-width relative">
                      <div className="h-auto flex flex-col Qsmd:flex-row justify-center w-full">
                        <div className="w-full Qsmd:w-width-md flex flex-row justify-start items-center px-padding-md Qsmd:pl-padding-sm py-padding-md Qsmd:pr-padding-md">
                          <TitleSubtitlePair
                            title={scheduleName}
                            variant="md"
                            subtitle="Schedule name"
                            titleColor="text-primary"
                          />
                        </div>

                        <hr className="border-primary-bg relative z-z-index-content Qsmd:hidden mx-margin-md Qlg:mx-margin-base"></hr>
                        <div className="hidden Qsmd:block border-r border-solid pl-padding-xs border-primary-bg my-margin-md"></div>
                        <div className="sched-txn-amount-div w-full py-padding-md Qsmd:py-padding-base flex Qsmd:flex-row justify-between items-stretch text-text-primary Qsmd:w-width-lg">
                          <div className="sched-txn-amount flex flex-col items-start pl-padding-md self-center">
                            <TitleSubtitlePair
                              title={
                                scheduleAmt
                                  ? `INR ${FormatAmount({ price: scheduleAmt })}`
                                  : "N/A"
                              }
                              subtitle="Amount"
                              titleColor={
                                scheduleAmt ? "settled" : "text-primary"
                              }
                              isBold={true}
                            />
                          </div>

                          <div className="flex flex-row bg-primary-nav-act">
                            <div
                              className={` ${
                                isScheduleConfidential
                                  ? " "
                                  : "w-auto h-height-full"
                              } hidden Qsmd:flex flex-row justify-evenly items-center `}
                            >
                              {isScheduleConfidential && (
                                <>
                                  <TopNavSmallButton
                                    btnText={
                                      <>
                                        {globalText?.CONFIDENTIAL}
                                        <br />
                                        {globalText?.history}
                                      </>
                                    }
                                    btnType="button"
                                    handleFunction={() =>
                                      isPopup
                                        ? actionRestricted()
                                        : setShowScheduleConfidentialPopup(true)
                                    }
                                    isDisabled={isPopup}
                                    enabledTextColor="var(--text-primary)"
                                    enabledBgColor="var(--primary-nav-act)"
                                    disabledBgColor="var(--primary-nav-act)"
                                    icon={ICONS?.CONFIDENTIAL_TRANSACTION}
                                    hoverOption="white"
                                    fullWidthRequired={false}
                                  />
                                </>
                              )}
                            </div>
                            {isScheduleConfidential && (
                              <div className="border-r border-primary-bg my-margin-md hidden Qsmd:flex"></div>
                            )}
                            <div className="hidden Qsmd:flex flex-row">
                              <TopNavSmallButton
                                btnText={scheduleCategory?.category_name}
                                btnType="button"
                                handleFunction={() =>
                                  isPopup
                                    ? actionRestricted()
                                    : setShowScheduleCategoryPopup(true)
                                }
                                isDisabled={isPopup}
                                enabledTextColor="var(--text-primary)"
                                enabledBgColor="var(--primary-nav-act)"
                                disabledBgColor="var(--primary-nav-act)"
                                icon={categoryIcon?.url}
                                imgColor={categoryIcon?.colour}
                                hoverOption="white"
                                fullWidthRequired={false}
                                isBackgroundRequired={true}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <hr className="border-primary-bg relative z-z-index-content mx-margin-md Qlg:mx-margin-base"></hr>
                      <div className="flex flex-col Qsmd:flex-row justify-center w-full">
                        <div className="text-text-primary Qsmd:w-width-md flex flex-col items-center justify-between">
                          <div className="flex flex-row items-center justify-between w-full px-padding-sm pt-padding-sm Qsmd:p-padding-base Qsmd:pt-padding-md">
                            <TitleSubtitlePair
                              isDisabled={
                                !services?.includes("VAccount") || isPopup
                              }
                              alignRight={false}
                              title={formatAccountNumber(scheduleSrcAcctNumber)}
                              titleColor={"text-primary"}
                              subtitle={"Source account"}
                              onClick={() => {
                                if (!services?.includes("VAccount")) {
                                  navigate("/feature_not_assigned", {
                                    state: {
                                      unavailableService: "VAccount",
                                    },
                                  });
                                } else if (isPopup) {
                                  actionRestricted();
                                } else {
                                  navigate(
                                    `/owner_account_dashboard/owner_accounts_view_all/owner_accounts_detail_page/${scheduleSrcId}`,
                                  );
                                }
                              }}
                              info={false}
                              showArrow={true}
                              hoverOption={"white"}
                              isBold={false}
                              variant={"md"}
                            />

                            <CommonBankLogo
                              ifsc={scheduleSrcIFSC}
                              variant="big"
                              type="pill"
                            />
                          </div>
                          <div className="hidden Qsmd:flex flex-row justify-between items-center w-full Qsmd:pb-padding-md Qsmd:pl-padding-sm">
                            <TitleSubtitlePair
                              isDisabled={false}
                              alignRight={false}
                              title={scheduleSrcIFSC}
                              titleColor={"text-primary"}
                              subtitle={"IFSC code"}
                              info={false}
                              showArrow={false}
                              isBold={false}
                              variant={"md"}
                            />

                            <TitleSubtitlePair
                              isDisabled={false}
                              textAlign={"right"}
                              title={schedulePaymentMethod}
                              titleColor={"text-primary"}
                              subtitle={"Payment method"}
                              info={false}
                              showArrow={false}
                              isBold={false}
                              variant={"md"}
                            />
                          </div>
                        </div>
                        <div className="w-icon-md my-auto h-height-base Qsmd:h-stepper-header flex flex-col justify-around items-center mx-auto Qsmd:mx-margin-base Qsmd:ml-margin-xs">
                          <div className="hidden Qsmd:block verical-filler border-r border-primary-bg h-height-sm"></div>
                          <div className="hidden Qsmd:flex arrow-icon h-icon-md w-icon-md">
                            <img
                              src={ICONS?.ARROW_RIGHT_BLUE_WHITE}
                              className="w-icon-md h-icon-md"
                              alt="arrow"
                            />
                          </div>

                          <div className="hidden  Qmd:block verical-filler border-r border-primary-bg h-height-sm"></div>
                        </div>
                        <div className="flex items-center gap-gap-sm justify-start Qlg:px-padding-md Qsmd:hidden mx-margin-md Qlg:mx-margin-base">
                          <div className="w-width-md border-b border-primary-bg"></div>
                          <div className="w-icon-md">
                            <img
                              src={ICONS?.ARROW_DOWN_BLUE_WHITE}
                              alt="arrowDownBlueWhite"
                            />
                          </div>
                          <div className="w-width-md border-b border-primary-bg"></div>
                        </div>
                        <div className="text-text-primary w-full Qsmd:w-width-lg flex flex-col items-start justify-between">
                          <div className="flex flex-row w-full justify-between">
                            <div className="flex flex-col gap-gap-sm w-full">
                              <div className="flex flex-row w-full justify-between px-padding-sm Qsmd:px-padding-base gap-gap-sm items-center pt-padding-sm Qsmd:pt-padding-md">
                                <TitleSubtitlePair
                                  isDisabled={
                                    !services?.includes("BVAccount") || isPopup
                                  }
                                  alignRight={false}
                                  title={formatAccountNumber(
                                    scheduleBeneAcctNumber,
                                  )}
                                  titleColor={"text-primary"}
                                  subtitle={"Destination account"}
                                  onClick={() => {
                                    if (!services?.includes("BVAccount")) {
                                      navigate("/feature_not_assigned", {
                                        state: {
                                          unavailableService: "BVAccount",
                                        },
                                      });
                                    } else if (isPopup) {
                                      actionRestricted();
                                    } else {
                                      navigate(
                                        `/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/${scheduleBeneId}`,
                                      );
                                    }
                                  }}
                                  info={false}
                                  showArrow={true}
                                  hoverOption={"white"}
                                  isBold={false}
                                  variant={"md"}
                                />

                                <div className="Qsmd:mr-margin-md">
                                  <CommonBankLogo
                                    ifsc={scheduleBeneIFSC}
                                    variant="big"
                                    type="pill"
                                  />
                                </div>
                              </div>
                              <hr className="border-primary-bg relative z-z-index-content Qsmd:hidden mx-margin-md Qlg:mx-margin-base"></hr>
                              <div className="pl-padding-md pt-padding-sm pb-padding-md Qsmd:hidden">
                                <TitleSubtitlePair
                                  isDisabled={false}
                                  title={schedulePaymentMethod}
                                  titleColor={"text-primary"}
                                  subtitle={"Payment method"}
                                  info={false}
                                  showArrow={false}
                                  isBold={false}
                                  variant={"md"}
                                />
                              </div>
                            </div>

                            <div className="hidden Qsmd:flex bg-primary-nav-act">
                              {/* <div className="dummydiv">
                                <TopNavSmallButton
                                  btnText={
                                    <>
                                      {globalText?.ASSIGN}
                                      <br />
                                      {globalText?.LABELS}
                                    </>
                                  }
                                  btnType="button"
                                  icon={ICONS?.LABEL_WITH_CIRCLE}
                                  handleFunction={(e) => {
                                    e.stopPropagation();
                                    if (
                                      !services?.includes("ALabel") &&
                                      !services?.includes("RLabel")
                                    ) {
                                      navigate("/feature_not_assigned", {
                                        state: {
                                          unavailableService: "ALabel,RLabel",
                                        },
                                      });
                                      return;
                                    }
                                    if (isPopup) {
                                      actionRestricted();
                                      return;
                                    }
                                    setShowLabelsPopup(true);
                                  }}
                                  isDisabled={
                                    isPopup ||
                                    (!services?.includes("ALabel") &&
                                      !services?.includes("RLabel"))
                                  }
                                  enabledTextColor="var(--text-primary)"
                                  enabledBgColor="var(--primary-nav-act)"
                                  disabledBgColor="var(--primary-nav-act)"
                                  hoverOption="white"
                                  fullWidthRequired={false}
                                />
                              </div> */}
                              {/* <div className="border-r border-primary-bg my-margin-md"></div> */}
                              <TopNavSmallButton
                                btnText={
                                  <>
                                    {globalText?.SCHEDULE} <br />{" "}
                                    {globalText?.history}
                                  </>
                                }
                                btnType="button"
                                handleFunction={() =>
                                  isPopup
                                    ? actionRestricted()
                                    : setShowScheduleHistoryPopup(true)
                                }
                                isDisabled={isPopup}
                                enabledTextColor="var(--text-primary)"
                                enabledBgColor="var(--primary-nav-act)"
                                disabledBgColor="var(--primary-nav-act)"
                                icon={ICONS?.TRANSACTION_HISTORY}
                                hoverOption="white"
                                fullWidthRequired={false}
                              />
                            </div>
                          </div>

                          <div className="hidden Qsmd:flex flex-row justify-between items-center gap-gap-xl w-full Qsmd:items-end">
                            <div className="pl-padding-sm pt-padding-md Qsmd:pb-padding-md ">
                              <TitleSubtitlePair
                                isDisabled={false}
                                alignRight={false}
                                title={scheduleBeneIFSC}
                                titleColor={"text-primary"}
                                subtitle={"IFSC code"}
                                info={false}
                                showArrow={false}
                                isBold={false}
                                variant={"md"}
                              />
                            </div>
                            <div className="w-icon-md"></div>
                            <div className="flex flex-row">
                              <div className="border-t border-primary-bg">
                                {!scheduleDeleted && (
                                  <>
                                    <div className="hidden Qsmd:flex">
                                      <TopNavSmallButton
                                        btnText={
                                          <>
                                            {globalText?.DISCARD} <br />
                                            {globalTextFormat(
                                              globalText?.SCHEDULE,
                                            )}
                                          </>
                                        }
                                        btnType="button"
                                        handleFunction={() => {
                                          if (isPopup) {
                                            actionRestricted();
                                          } else if (hasModService) {
                                            setShowPromptModal(true);
                                          } else {
                                            navigate("/feature_not_assigned", {
                                              state: {
                                                unavailableService:
                                                  "BAScheduledTxn",
                                              },
                                            });
                                          }
                                        }}
                                        isDisabled={!hasModService || isPopup}
                                        enabledTextColor="var(--text-primary)"
                                        enabledBgColor="var(--primary-nav-act)"
                                        disabledBgColor="var(--primary-nav-act)"
                                        icon={ICONS?.DELETE_WITH_WHITE_CIRCLE}
                                        hoverOption="white"
                                        fullWidthRequired={false}
                                      />
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="block Qsmd:hidden">
                      {!(isScheduleApproved || scheduleDeleted) && (
                        <TimelineStatusBar
                          overrideAutoLoader
                          showMobile={true}
                          whichBtnClicked={btnClicked?.[scheduleId] || "none"}
                          failedToTakeaction={
                            !!scheduleApproveFailed ||
                            scheduledBeneficiaryRejectError
                          }
                          failedToTakeIcon={true}
                          failedToTakeactionReason={
                            scheduleApproveFailedMessage ||
                            scheduledBeneficiaryRejectError?.errors?.base?.[0]
                              ?.errors?.[0]
                          }
                          rejected={isScheduleRejected && !scheduleDeleted}
                          rejectedReason={scheduleRejectMessage}
                          accountApprovalPending={
                            !isScheduleApproved &&
                            !scheduleDeleted &&
                            !scheduleBeneApproved
                          }
                          handleApprovalPendingBtn={() =>
                            services?.includes("BAAccount")
                              ? setShowBeneAccModal(true)
                              : navigate("/feature_not_assigned", {
                                  state: {
                                    unavailableService: "BAAccount",
                                  },
                                })
                          }
                          isApprovalPendingDisabled={
                            !services?.includes("AInternalTxn")
                          }
                          pending={
                            !isScheduleApproved &&
                            !scheduleDeleted &&
                            scheduleBeneApproved
                          }
                          accountApprovalPendingSubHeader={
                            services?.includes("BAScheduledTxn")
                              ? "Account is not approved, approve account before approving transaction."
                              : "To approve the account, please contact the authorized person."
                          }
                          rejectMobClick={() => {
                            if (hasModService) {
                              setbtnClicked((prev) => ({
                                ...prev,
                                [scheduleId]: "Reject",
                              }));
                              setShowRejectPrompt(true);
                            } else {
                              navigate("/feature_not_assigned", {
                                state: {
                                  unavailableService: "BAScheduledTxn",
                                },
                              });
                            }
                          }}
                          isRejectMobDisable={!hasModService}
                          approveMobClick={onApproveClick}
                          isApproveMobDisable={!hasModService}
                          rejectBtnText={
                            <>
                              Reject <br /> Schedule
                            </>
                          }
                          approveBtnText={
                            <>
                              Approve <br /> Schedule
                            </>
                          }
                        />
                      )}
                    </div>
                  </div>
                </div>
                <div
                  className={`flex flex-row justify-center bg-primary-bg Qsmd:flex-1 ${index === GlobalConfiguration?.lengthCheckTwo ? "" : ""}`}
                >
                  <div className="max-w-screen-Qlg w-width-full flex flex-col mt-margin-md">
                    <div className="block Qsmd:hidden">
                      <CommonQuickActionButtons
                        title="Quick Actions"
                        actions={[
                          {
                            key: "schedule-category",
                            btnText: scheduleCategory?.category_name,
                            btnType: "button",
                            handleFunction: runIfNotPopup(() =>
                              setShowScheduleCategoryPopup(true),
                            ),
                            isDisabled: isPopup,
                            icon: categoryIcon?.url,
                            imgColor: categoryIcon?.colour,
                            isBackgroundRequired: true,
                          },
                          {
                            key: "schedule-history",
                            btnText: (
                              <>
                                {globalText?.SCHEDULE}
                                <br />
                                {globalText?.history}
                              </>
                            ),
                            btnType: "button",
                            handleFunction: runIfNotPopup(() =>
                              setShowScheduleHistoryPopup(true),
                            ),
                            isDisabled: isPopup,
                            icon: ICONS?.TRANSACTION_HISTORY,
                          },
                          {
                            key: "confidential-history",
                            hidden: !isScheduleConfidential,
                            btnText: (
                              <>
                                {globalText?.CONFIDENTIAL}
                                <br />
                                {globalText?.history}
                              </>
                            ),
                            btnType: "button",
                            handleFunction: runIfNotPopup(() =>
                              setShowScheduleConfidentialPopup(true),
                            ),
                            isDisabled: isPopup,
                            icon: ICONS?.CONFIDENTIAL_TRANSACTION,
                          },
                          {
                            key: "discard-schedule",
                            hidden: scheduleDeleted,
                            btnText: (
                              <>
                                {globalText?.DISCARD}
                                <br />
                                {globalTextFormat(globalText?.SCHEDULE)}
                              </>
                            ),
                            btnType: "button",
                            handleFunction: runIfNotPopup(() => {
                              if (hasModService) {
                                safeSetShowPromptModal();
                              } else {
                                navigate("/feature_not_assigned", {
                                  state: {
                                    unavailableService: "IAScheduledTxn",
                                  },
                                });
                              }
                            }),
                            isDisabled: isPopup || !hasModService,
                            icon: ICONS?.DELETE_WITH_WHITE_CIRCLE,
                          },
                        ]}
                      />
                    </div>
                    <>
                      <div
                        className={`Qlg:mx-margin-base ml-margin-md mr-margin-md mt-margin-md Qlg:mr-margin-base Qsmd:mx-margin-md flex flex-row items-end ${
                          !(
                            isScheduleApproved ||
                            isScheduleRejected ||
                            scheduleDeleted
                          )
                            ? "Qsmd:justify-center justify-start"
                            : "justify-start"
                        } `}
                      >
                        <div
                          className={`relative w-timeline-status-card-width h-height-full bg-primary-card rounded-l-border-radius-md rounded-tr-border-radius-md Qsmd:w-width-sm ${
                            isScheduleApproved || scheduleDeleted
                              ? "rounded-br-border-radius-md"
                              : "rounded-br-border-radius-md Qsmd:rounded-br-none"
                          } `}
                        >
                          <div className="w-full h-height-full text-text-primary bg-primary-nav relative rounded-border-radius-md">
                            <div className="text-font-xs py-padding-sm px-padding-md font-semibold">
                              Schedule timeline
                            </div>
                            <hr className="relative left-left-base border-primary-bg border-t-border mx-margin-md" />

                            <div>
                              <CommonTimeLineCard
                                logsData={scheduleUpdatedData?.transaction}
                                handleApprovalClick={handleTimelinePopup}
                                showApprovalTimeline={true}
                                showDistributionTimeline={false}
                                showDistributionRightIcon={true}
                                showApprovalLeftIcon={true}
                                showApprovalDuration={true}
                                cardType={"single"}
                                isDisabled={isPopup ? true : false}
                                leftCardTitle="Stage - Approval"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="hidden Qsmd:flex flex-col flex-grow w-width-md">
                          {scheduleUpdatedData?.transaction?.map((txn) => {
                            return (
                              <TimelineStatusBar
                                overrideAutoLoader
                                hasDistributionData={false}
                                showMobile={false}
                                failedToTakeaction={
                                  !!scheduleApproveFailed ||
                                  scheduledBeneficiaryRejectError
                                }
                                failedToTakeIcon={true}
                                failedToTakeactionReason={
                                  scheduleApproveFailedMessage ||
                                  scheduledBeneficiaryRejectError?.errors
                                    ?.base?.[0]?.errors?.[0]
                                }
                                rejected={
                                  isScheduleRejected && !scheduleDeleted
                                }
                                rejectedReason={scheduleRejectMessage}
                                accountApprovalPending={
                                  !isScheduleApproved &&
                                  !scheduleDeleted &&
                                  !scheduleBeneApproved
                                }
                                handleApprovalPendingBtn={() =>
                                  services?.includes("BAAccount")
                                    ? setShowBeneAccModal(true)
                                    : navigate("/feature_not_assigned", {
                                        state: {
                                          unavailableService: "BAAccount",
                                        },
                                      })
                                }
                                isApprovalPendingDisabled={
                                  !services?.includes("AInternalTxn")
                                }
                                pending={
                                  !isScheduleApproved &&
                                  !scheduleDeleted &&
                                  scheduleBeneApproved
                                }
                                rejectClick={() => {
                                  if (hasModService) {
                                    setbtnClicked((prev) => ({
                                      ...prev,
                                      [scheduleId]: "Reject",
                                    }));
                                    setShowRejectPrompt(true);
                                  } else {
                                    navigate("/feature_not_assigned", {
                                      state: {
                                        unavailableService: "BAScheduledTxn",
                                      },
                                    });
                                  }
                                }}
                                isRejectDisable={!hasModService}
                                approveClick={onApproveClick}
                                isApproveDisable={!hasModService}
                                whichBtnClicked={
                                  btnClicked?.[scheduleId] || "none"
                                }
                                accountApprovalPendingSubHeader={
                                  services?.includes("BAScheduledTxn")
                                    ? "Account is not approved, approve account before approving transaction."
                                    : "To approve the account, please contact the authorized person."
                                }
                                rejectBtnText={
                                  <>
                                    Reject <br /> Schedule
                                  </>
                                }
                                approveBtnText={
                                  <>
                                    Approve <br /> Schedule
                                  </>
                                }
                              />
                            );
                          })}
                        </div>
                      </div>
                    </>
                    <div
                      className={`w-full max-w-screen-Qlg bg-primary-bg flex flex-col flex-1 ${index === GlobalConfiguration?.lengthCheckThree ? "" : "px-padding-md lg:px-padding-base"}`}
                      style={{ scrollbarWidth: "none" }}
                    >
                      <>
                        <div
                          className={`${index === GlobalConfiguration?.lengthCheckTwo ? "py-padding-md !pb-padding-base" : "py-padding-md"} flex overflow-x-auto`}
                          style={{ scrollbarWidth: "none" }}
                        >
                          <div
                            className={`flex gap-gap-sm bg-primary-card w-auto rounded-border-radius-md ${index === GlobalConfiguration?.lengthCheckThree ? "mx-margin-md lg:mx-margin-base" : ""}`}
                          >
                            <SwitcherTabs
                              initialActiveTab={
                                selectedDetail === "Additional details"
                                  ? "Additional details"
                                  : selectedDetail === "Transaction created"
                                    ? "Transaction created"
                                    : selectedDetail === "Assigned Labels"
                                      ? "Assigned Labels"
                                      : "Details"
                              }
                              tabs={[
                                {
                                  label: "Details",
                                  key: "Details",
                                  handler: () => {
                                    setSelectedDetail("Details");
                                    setIndex(
                                      GlobalConfiguration?.lengthCheckZero,
                                    );
                                  },
                                },
                                {
                                  label: "Additional details",
                                  key: "Additional details",
                                  handler: () => {
                                    setSelectedDetail("Additional details");
                                    setIndex(
                                      GlobalConfiguration?.lengthCheckOne,
                                    );
                                  },
                                },
                                ...(scheduleBeneTxnList.length >
                                GlobalConfiguration?.lengthCheckZero
                                  ? [
                                      {
                                        label: "Transaction created",
                                        key: "Transaction created",
                                        handler: () => {
                                          setSelectedDetail(
                                            "Transaction created",
                                          );
                                          setIndex(
                                            GlobalConfiguration?.lengthCheckTwo,
                                          );
                                        },
                                      },
                                    ]
                                  : []),
                                {
                                  label: "Labels",
                                  key: "Assigned Labels",
                                  handler: () => {
                                    setSelectedDetail("Assigned Labels");
                                    setIndex(
                                      GlobalConfiguration?.lengthCheckThree,
                                    );
                                  },
                                },
                              ]}
                              setIndex={setIndex}
                            />
                          </div>
                        </div>
                      </>
                      <div className="relative flex flex-col flex-1">
                        {index === GlobalConfiguration?.lengthCheckZero && (
                          <div className={animationClass}>
                            <div className="flex flex-col items-center Qsmd:items-start Qsmd:flex-row gap-gap-md pb-padding-md">
                              <CommonDetailCard
                                cardTitle="Origin details"
                                variant="third"
                                numCols={GlobalConfiguration?.lengthCheckOne}
                                entries={[
                                  {
                                    content: scheduleCreatedBy,
                                    heading: "Created by",
                                    type: "text",
                                  },
                                  {
                                    content: scheduleCreatedOn
                                      ? formatDateViewAll(
                                          scheduleCreatedOn,
                                          true,
                                          true,
                                        )
                                      : "—",
                                    heading: "On date",
                                    type: "text",
                                  },
                                ]}
                              />

                              <CommonDetailCard
                                cardTitle="Transfer details"
                                variant="third"
                                numCols={GlobalConfiguration?.lengthCheckOne}
                                entries={[
                                  {
                                    content: [
                                      scheduleFrequency.split("_").join(" "),
                                    ].map(
                                      (s) =>
                                        s
                                          .charAt(
                                            GlobalConfiguration?.lengthCheckZero,
                                          )
                                          .toUpperCase() +
                                        s.slice(
                                          GlobalConfiguration?.lengthCheckOne,
                                        ),
                                    ),
                                    heading: "Frequency",
                                    type: "text",
                                  },
                                  {
                                    content: scheduleStartDate
                                      ? formatDate(scheduleStartDate)
                                      : "—",
                                    heading: "Start date",
                                    type: "text",
                                  },
                                  {
                                    content: scheduleEndDate
                                      ? formatDate(scheduleEndDate)
                                      : "—",
                                    heading: "End date",
                                    type: "text",
                                  },
                                  {
                                    content: scheduleTimeSlot
                                      ? formatTimeSlot(scheduleTimeSlot)
                                      : "—",
                                    heading: "Time slot",
                                    type: "text",
                                  },
                                  {
                                    content: scheduleOccurrences,
                                    heading: "Occurrences",
                                    onClick: () => {
                                      if (isPopup) {
                                        actionRestricted();
                                      } else if (hasOccurrenceService) {
                                        handleShowOccurrences();
                                      } else {
                                        navigate("/feature_not_assigned", {
                                          state: {
                                            unavailableService:
                                              "BOScheduledTxn",
                                          },
                                        });
                                      }
                                    },
                                    isDisabled:
                                      !hasOccurrenceService || isPopup,
                                    type: "text",
                                  },
                                ]}
                              />
                            </div>
                          </div>
                        )}

                        {index === GlobalConfiguration?.lengthCheckOne &&
                          detailSectionAdditionalDetailsDiv}

                        {index === GlobalConfiguration?.lengthCheckTwo && (
                          <div
                            className={`${animationClass} flex flex-col flex-1`}
                          >
                            <div
                              className="flex flex-col Qsmd:flex-row gap-y-gap-md gap-x-gap-sm flex-wrap h-full"
                              style={{ scrollbarWidth: "none" }}
                            >
                              {isloading ? (
                                <div className="w-full flex justify-center items-center py-padding-md">
                                  <Loader />
                                </div>
                              ) : (
                                <BeneficiaryTransactionGridView
                                  filterRef={scrollContainerRef}
                                  data={transactionData?.payload?.transactions}
                                  typepop={"schedDetailViewAll"}
                                />
                              )}
                            </div>
                            {/* <div className="h-height-full" /> */}
                          </div>
                        )}

                        {index === GlobalConfiguration?.lengthCheckThree && (
                          <div className={animationClass}>
                            <div className="mb-margin-md">
                              <CommonContainerCard
                                header="Labels"
                                iconIsDisabled={
                                  !(
                                    services?.includes("ALabel") &&
                                    services?.includes("RLabel")
                                  ) || isPopup
                                }
                                subheader={globalText?.LABELS_USAGE_NOTE}
                                icon={ICONS?.EDIT}
                                handleFunction={(e) => {
                                  e.stopPropagation();
                                  if (
                                    !(
                                      services?.includes("ALabel") &&
                                      services?.includes("RLabel")
                                    )
                                  ) {
                                    navigate("/feature_not_assigned", {
                                      state: {
                                        unavailableService: "ALabel,RLabel",
                                      },
                                    });
                                    return;
                                  }
                                  if (isPopup) {
                                    actionRestricted();
                                    return;
                                  }
                                  setShowLabelsPopup(true);
                                }}
                              >
                                <div className="flex flex-wrap w-full gap-gap-sm overflow-x-auto">
                                  {Array.isArray(labelDetails) &&
                                  labelDetails.length ? (
                                    labelDetails.map((item, idx) => (
                                      <Chips
                                        key={idx}
                                        txtChip={item}
                                        enabledBgColor="var(--primary-nav)"
                                        disableIcon={true}
                                        handleFunction={(e) => {
                                          e.stopPropagation();
                                        }}
                                        enabledTextColor="var(--text-primary)"
                                      />
                                    ))
                                  ) : (
                                    <p className="text-font-sm text-text-primary">
                                      No labels assigned.
                                    </p>
                                  )}
                                </div>
                              </CommonContainerCard>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {index === GlobalConfiguration?.lengthCheckTwo && !isloading && (
              <div className="h-pagination-height flex-shrink-0"></div>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default ScheduleBeneficiaryTransactionDetails;
